export enum UserTypesEnum {
  regular = 'regular',
  substitute = 'substitute',
}
